// El viewport de la app INSTALADA: sin zoom automático ni por gesto.
//
// iOS acerca la página cuando enfocas un campo cuya letra computa bajo 16px, y
// NO la devuelve al salir. Con la densidad global de 14.4px (src/index.css),
// 160 de los 165 campos de MiPAE caían bajo ese umbral, así que a la segunda
// tester del build 2157 (2026-09-03) la app "hacía zoom de la nada" y quedaba
// pegada así: Capacitor apaga el pellizco en iOS, o sea no había cómo volver.
// Eso es lo que ella describió como "se buguea".
//
// La causa raíz se arregla en CSS (los controles suben a 16px en pantalla
// táctil). Esto es el cinturón: en un WKWebView, a diferencia de Safari, el
// meta viewport SÍ se respeta, así que maximum-scale=1 apaga el zoom al
// enfocar aunque un campo nuevo nazca chico mañana.
//
// SOLO en la app nativa. En la web NO se toca el viewport: apagar el zoom del
// usuario es una barrera de accesibilidad (WCAG 1.4.4) y ahí el pellizco es la
// forma en que alguien con baja visión lee. public/index.html es el mismo HTML
// que sirve mipae.cl, por eso el cambio se aplica en tiempo de ejecución y no
// en el archivo.
//
// Kill-switch ON por defecto.
export const VIEWPORT_NATIVO_ENABLED = process.env.REACT_APP_VIEWPORT_NATIVO_ENABLED !== 'false';

const CLAVES_ZOOM = ['maximum-scale', 'user-scalable'];

// Puro: recibe el `content` actual del meta viewport y devuelve el que
// corresponde en nativo. Conserva TODO lo que ya venía (viewport-fit=cover para
// el notch, interactive-widget=resizes-content del que depende
// hooks/useTecladoAbierto.js) y solo fija las dos claves del zoom. Idempotente.
export function viewportParaNativo(content) {
  const tokens = String(content || '')
    .split(',')
    .map((t) => t.trim())
    .filter(Boolean)
    .filter((t) => !CLAVES_ZOOM.includes(t.split('=')[0].trim()));
  if (!tokens.some((t) => t.startsWith('width='))) tokens.unshift('width=device-width');
  if (!tokens.some((t) => t.startsWith('initial-scale='))) tokens.push('initial-scale=1');
  tokens.push('maximum-scale=1', 'user-scalable=no');
  return tokens.join(', ');
}

// Toca el DOM. Devuelve true si cambió algo.
export function aplicarViewportNativo({ nativo, doc = typeof document !== 'undefined' ? document : null } = {}) {
  if (!nativo || !VIEWPORT_NATIVO_ENABLED || !doc) return false;
  const meta = doc.querySelector('meta[name="viewport"]');
  if (!meta) return false;
  const actual = meta.getAttribute('content') || '';
  const nuevo = viewportParaNativo(actual);
  if (nuevo === actual) return false;
  meta.setAttribute('content', nuevo);
  return true;
}
